module.exports = __webpack_public_path__ + "static/media/DisclaimerNOD.7de29962.pdf";